import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { BroadcastDeviceBanner } from '@magnetar/data-access'

interface CreateBannerData {
  broadcast_device_id: number
  file_uuid: string
  is_active: boolean
  stay_time: number
}

export const broadcastDeviceBannerService = {
  createBanner: async (broadcastDeviceId: number, data: CreateBannerData, token: string) => {
    try {
      const response = await apiClient.post<ApiResponse<BroadcastDeviceBanner>>(
        `/api/broadcast-device/${broadcastDeviceId}/banner`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'CREATE_BANNER_FAILED',
          message: '新增橫幅失敗',
        },
      }
    }
  },

  deleteBanner: async (broadcastDeviceId: number, bannerId: number, token: string) => {
    try {
      const response = await apiClient.delete<ApiResponse<void>>(
        `/api/broadcast-device/${broadcastDeviceId}/banner/${bannerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'DELETE_BANNER_FAILED',
          message: '刪除橫幅失敗',
        },
      }
    }
  },

  updateBannerOrder: async (broadcastDeviceId: number, bannerIds: number[], token: string) => {
    try {
      const response = await apiClient.put<ApiResponse<void>>(
        `/api/broadcast-device/${broadcastDeviceId}/banner/order`,
        { banner_ids: bannerIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UPDATE_BANNER_ORDER_FAILED',
          message: '更新橫幅順序失敗',
        },
      }
    }
  },

  updateBannerStayTime: async (bannerId: number, stayTimeMs: number, token: string) => {
    try {
      const response = await apiClient.put<ApiResponse<BroadcastDeviceBanner>>(
        `/api/broadcast-device/banner/${bannerId}/stay-time`,
        { stay_time: stayTimeMs },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UPDATE_BANNER_STAY_TIME_FAILED',
          message: '更新橫幅停留時間失敗',
        },
      }
    }
  },
}
